import { VIN_LENGTH } from "helpers/dictionary";

export const initialValues = {
  values: {
    idStation: null,
    ecoPart1: "",
    ecoPart2: "",
    ecoPart3: "",
    number: "",
    type: null,
    deliveryType: null,
    fuel: null,
    capacity: 0,
    capacity_: "",
    flowMeter: 0,
    flowMeter_: "",
    creLicense: null,
    unitPlates: "",
    idealPercentage: 0,
    idealPercentage_: "",
    brand: "",
    subModel: "",
    serieNumber: "",
  },
  required: {
    idStation: { required: true },
    ecoPart1: { required: true },
    ecoPart2: { required: true },
    ecoPart3: { required: true },
    type: { required: true },
    deliveryType: { required: true },
    fuel: { required: true },
    capacity: { required: true },
    flowMeter: { required: true },
    creLicense: { required: true },
    unitPlates: { required: true, maxLength: 10 },
    idealPercentage: {
      min: 0,
      max: 100,
      message: "* Deben ser al menos 0 y máximo 100",
    },
    brand: { required: true },
    subModel: { required: true },
    serieNumber: { required: true, minLength: 10, maxLength: VIN_LENGTH },
  },

  employeesValues: {
    idEmployee: null,
    idHelper: null,
    idSecondHelper: null,
  },
};

export const billingValidations = {
  selectedStation: {
    required: true,
  },
  selectedCreLicense: {
    required: true,
  },
  unitPlates: {
    required: true,
  },
  insurance: {
    required: true,
  },
  insurancePolicy: {
    required: true,
  },
  insurancePolicyValue: {
    required: true,
  },
  unitModel: {
    required: true,
    exactLength: 4,
  },
  unitWeight: {
    required: true,
  },
  kmEstimation: {
    required: true,
  },
  vehicleConfig: {
    required: true,
  },
};
